<script lang="ts">
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const models = service.store.features
</script>

<div class="{klass}">
	<FormWithLabel
		label="こだわり"
		input={service.handleFeatures}
		values={$model.features}
		inputType="checkboxes"
		options={$models}
	/>
</div>